import { default as index3fLZKt80a0Meta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/index.vue?macro=true";
import { default as completeJWQes6lgPhMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/complete.vue?macro=true";
import { default as mobile_45verificationlGcljh1sf7Meta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/mobile-verification.vue?macro=true";
import { default as sign_45in5cZERf73LAMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/sign-in.vue?macro=true";
import { default as _91_46_46_46slug_933qRDcnCv2MMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[...slug].vue?macro=true";
import { default as _91employee_reference_93hjCvCCfwoiMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[employee_reference].vue?macro=true";
import { default as confirmuE06lwlsVtMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/confirm.vue?macro=true";
import { default as finishedjKfm6I2DxpMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/finished.vue?macro=true";
import { default as indexggYb2UwS1LMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/index.vue?macro=true";
import { default as confirmGqUQfCntmDMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/[booking_id]/confirm.vue?macro=true";
import { default as checkoutc7dRVBYTJ8Meta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/checkout.vue?macro=true";
import { default as employees2r3aNKEIe0Meta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/employees.vue?macro=true";
import { default as review_45and_45confirmEqVmrmC6HQMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/review-and-confirm.vue?macro=true";
import { default as servicesrUl4YizpwxMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/services.vue?macro=true";
import { default as timesGAtobKYg1qMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/times.vue?macro=true";
import { default as checkout6bIsPGDGzTMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/checkout.vue?macro=true";
import { default as finishedAUJcvQj7nNMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/finished.vue?macro=true";
import { default as indexLTaqrLpLdGMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/index.vue?macro=true";
import { default as review_45and_45confirmpHxDtxHvd2Meta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/review-and-confirm.vue?macro=true";
import { default as closedjXSpFViMAYMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/closed.vue?macro=true";
import { default as checkoutb5aqjR0JPoMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/checkout.vue?macro=true";
import { default as finishedxzPF7DkZQNMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/finished.vue?macro=true";
import { default as index4n6ORZ3YIbMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/index.vue?macro=true";
import { default as review_45and_45confirmcc1qjCuMruMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/review-and-confirm.vue?macro=true";
import { default as indexU5OcKHHkJfMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/index.vue?macro=true";
import { default as checkoutdA3m1ZKQ4sMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/checkout.vue?macro=true";
import { default as finishedYV39mFQVseMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/finished.vue?macro=true";
import { default as indexeMH2kPrkXfMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/index.vue?macro=true";
import { default as review_45and_45confirmAPLQ8W10ZZMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/review-and-confirm.vue?macro=true";
import { default as _91_46_46_46slug_93oFJwVNAat2Meta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[...slug].vue?macro=true";
import { default as _91id_93E3ODSTE98lMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[id].vue?macro=true";
import { default as indexvctjt23AjiMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/index.vue?macro=true";
import { default as _91slug_93DRYCHPhXDWMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/business-types/[slug].vue?macro=true";
import { default as indexWJwxevf89WMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/business-types/index.vue?macro=true";
import { default as contact_45salesfzT1Bb7i8MMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/contact-sales.vue?macro=true";
import { default as contact_45usK0o6IYM1CWMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/contact-us.vue?macro=true";
import { default as faqssiB4FDIIeGMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/faqs.vue?macro=true";
import { default as featuresOn9y2GfMHpMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/features.vue?macro=true";
import { default as privacy_45policyoTRQoWsrZzMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/privacy-policy.vue?macro=true";
import { default as request_45demoAmN3fHNzXIMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/request-demo.vue?macro=true";
import { default as bookingsU8iC6CTcwKMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/bookings.vue?macro=true";
import { default as change_45emailBVEOOvYZjsMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/change-email.vue?macro=true";
import { default as change_45mobileHINmejLMh5Meta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue?macro=true";
import { default as deleteWiFeWjmL7IMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/delete.vue?macro=true";
import { default as indexlY1trGZ0VgMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/index.vue?macro=true";
import { default as my_45gift_45cardsWQceEdk5wkMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/my-gift-cards.vue?macro=true";
import { default as my_45membershipszY9sAzuTtkMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/my-memberships.vue?macro=true";
import { default as overdueELYTIYCgubMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/overdue.vue?macro=true";
import { default as paidb90QLIPW2rMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/paid.vue?macro=true";
import { default as product_45ordersvLaj95mgwUMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/product-orders.vue?macro=true";
import { default as settingsZNyow6wOj7Meta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/settings.vue?macro=true";
import { default as visited_45locationswVIXQ9EbfXMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/visited-locations.vue?macro=true";
import { default as walletVenzvYp6ThMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/wallet.vue?macro=true";
import { default as component_45stubycs6ORPvVsMeta } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@25.0.3_eslint@9.39.2_jiti@2.7.0__ioredis@5.8_ux4w6bd7yb4gnzk34fiubdm3wa/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubycs6ORPvVs } from "/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@25.0.3_eslint@9.39.2_jiti@2.7.0__ioredis@5.8_ux4w6bd7yb4gnzk34fiubdm3wa/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: index3fLZKt80a0Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/index.vue")
  },
  {
    name: "complete___en",
    path: "/en/complete",
    meta: completeJWQes6lgPhMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/complete.vue")
  },
  {
    name: "complete___ar",
    path: "/ar/complete",
    meta: completeJWQes6lgPhMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/complete.vue")
  },
  {
    name: "mobile-verification___en",
    path: "/en/mobile-verification",
    meta: mobile_45verificationlGcljh1sf7Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/mobile-verification.vue")
  },
  {
    name: "mobile-verification___ar",
    path: "/ar/mobile-verification",
    meta: mobile_45verificationlGcljh1sf7Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/mobile-verification.vue")
  },
  {
    name: "sign-in___en",
    path: "/en/sign-in",
    meta: sign_45in5cZERf73LAMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/sign-in.vue")
  },
  {
    name: "sign-in___ar",
    path: "/ar/sign-in",
    meta: sign_45in5cZERf73LAMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(auth)/sign-in.vue")
  },
  {
    name: "location_identifier-slug___en",
    path: "/en/:location_identifier()/:slug(.*)*",
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[...slug].vue")
  },
  {
    name: "location_identifier-slug___ar",
    path: "/ar/:location_identifier()/:slug(.*)*",
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[...slug].vue")
  },
  {
    name: "location_identifier-employee_reference___en",
    path: "/en/:location_identifier()/:employee_reference()",
    meta: _91employee_reference_93hjCvCCfwoiMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[employee_reference].vue")
  },
  {
    name: "location_identifier-employee_reference___ar",
    path: "/ar/:location_identifier()/:employee_reference()",
    meta: _91employee_reference_93hjCvCCfwoiMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/[employee_reference].vue")
  },
  {
    name: "location_identifier-b-reference-confirm___en",
    path: "/en/:location_identifier()/b-:reference()/confirm",
    meta: confirmuE06lwlsVtMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/confirm.vue")
  },
  {
    name: "location_identifier-b-reference-confirm___ar",
    path: "/ar/:location_identifier()/b-:reference()/confirm",
    meta: confirmuE06lwlsVtMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/confirm.vue")
  },
  {
    name: "location_identifier-b-reference-finished___en",
    path: "/en/:location_identifier()/b-:reference()/finished",
    meta: finishedjKfm6I2DxpMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/finished.vue")
  },
  {
    name: "location_identifier-b-reference-finished___ar",
    path: "/ar/:location_identifier()/b-:reference()/finished",
    meta: finishedjKfm6I2DxpMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/finished.vue")
  },
  {
    name: "location_identifier-b-reference___en",
    path: "/en/:location_identifier()/b-:reference()",
    meta: indexggYb2UwS1LMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/index.vue")
  },
  {
    name: "location_identifier-b-reference___ar",
    path: "/ar/:location_identifier()/b-:reference()",
    meta: indexggYb2UwS1LMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/b-[reference]/index.vue")
  },
  {
    name: "location_identifier-booking-booking_id-confirm___en",
    path: "/en/:location_identifier()/booking/:booking_id()/confirm",
    meta: confirmGqUQfCntmDMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/[booking_id]/confirm.vue")
  },
  {
    name: "location_identifier-booking-booking_id-confirm___ar",
    path: "/ar/:location_identifier()/booking/:booking_id()/confirm",
    meta: confirmGqUQfCntmDMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/[booking_id]/confirm.vue")
  },
  {
    name: "location_identifier-booking-checkout___en",
    path: "/en/:location_identifier()/booking/checkout",
    meta: checkoutc7dRVBYTJ8Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/checkout.vue")
  },
  {
    name: "location_identifier-booking-checkout___ar",
    path: "/ar/:location_identifier()/booking/checkout",
    meta: checkoutc7dRVBYTJ8Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/checkout.vue")
  },
  {
    name: "location_identifier-booking-employees___en",
    path: "/en/:location_identifier()/booking/employees",
    meta: employees2r3aNKEIe0Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/employees.vue")
  },
  {
    name: "location_identifier-booking-employees___ar",
    path: "/ar/:location_identifier()/booking/employees",
    meta: employees2r3aNKEIe0Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/employees.vue")
  },
  {
    name: "location_identifier-booking-review-and-confirm___en",
    path: "/en/:location_identifier()/booking/review-and-confirm",
    meta: review_45and_45confirmEqVmrmC6HQMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/review-and-confirm.vue")
  },
  {
    name: "location_identifier-booking-review-and-confirm___ar",
    path: "/ar/:location_identifier()/booking/review-and-confirm",
    meta: review_45and_45confirmEqVmrmC6HQMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/review-and-confirm.vue")
  },
  {
    name: "location_identifier-booking-services___en",
    path: "/en/:location_identifier()/booking/services",
    meta: servicesrUl4YizpwxMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/services.vue")
  },
  {
    name: "location_identifier-booking-services___ar",
    path: "/ar/:location_identifier()/booking/services",
    meta: servicesrUl4YizpwxMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/services.vue")
  },
  {
    name: "location_identifier-booking-times___en",
    path: "/en/:location_identifier()/booking/times",
    meta: timesGAtobKYg1qMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/times.vue")
  },
  {
    name: "location_identifier-booking-times___ar",
    path: "/ar/:location_identifier()/booking/times",
    meta: timesGAtobKYg1qMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/booking/times.vue")
  },
  {
    name: "location_identifier-cart-checkout___en",
    path: "/en/:location_identifier()/cart/checkout",
    meta: checkout6bIsPGDGzTMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/checkout.vue")
  },
  {
    name: "location_identifier-cart-checkout___ar",
    path: "/ar/:location_identifier()/cart/checkout",
    meta: checkout6bIsPGDGzTMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/checkout.vue")
  },
  {
    name: "location_identifier-cart-finished___en",
    path: "/en/:location_identifier()/cart/finished",
    meta: finishedAUJcvQj7nNMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/finished.vue")
  },
  {
    name: "location_identifier-cart-finished___ar",
    path: "/ar/:location_identifier()/cart/finished",
    meta: finishedAUJcvQj7nNMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/finished.vue")
  },
  {
    name: "location_identifier-cart___en",
    path: "/en/:location_identifier()/cart",
    meta: indexLTaqrLpLdGMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/index.vue")
  },
  {
    name: "location_identifier-cart___ar",
    path: "/ar/:location_identifier()/cart",
    meta: indexLTaqrLpLdGMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/index.vue")
  },
  {
    name: "location_identifier-cart-review-and-confirm___en",
    path: "/en/:location_identifier()/cart/review-and-confirm",
    meta: review_45and_45confirmpHxDtxHvd2Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/review-and-confirm.vue")
  },
  {
    name: "location_identifier-cart-review-and-confirm___ar",
    path: "/ar/:location_identifier()/cart/review-and-confirm",
    meta: review_45and_45confirmpHxDtxHvd2Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/cart/review-and-confirm.vue")
  },
  {
    name: "location_identifier-closed___en",
    path: "/en/:location_identifier()/closed",
    meta: closedjXSpFViMAYMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/closed.vue")
  },
  {
    name: "location_identifier-closed___ar",
    path: "/ar/:location_identifier()/closed",
    meta: closedjXSpFViMAYMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/closed.vue")
  },
  {
    name: "location_identifier-gift-cards-checkout___en",
    path: "/en/:location_identifier()/gift-cards/checkout",
    meta: checkoutb5aqjR0JPoMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/checkout.vue")
  },
  {
    name: "location_identifier-gift-cards-checkout___ar",
    path: "/ar/:location_identifier()/gift-cards/checkout",
    meta: checkoutb5aqjR0JPoMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/checkout.vue")
  },
  {
    name: "location_identifier-gift-cards-finished___en",
    path: "/en/:location_identifier()/gift-cards/finished",
    meta: finishedxzPF7DkZQNMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/finished.vue")
  },
  {
    name: "location_identifier-gift-cards-finished___ar",
    path: "/ar/:location_identifier()/gift-cards/finished",
    meta: finishedxzPF7DkZQNMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/finished.vue")
  },
  {
    name: "location_identifier-gift-cards___en",
    path: "/en/:location_identifier()/gift-cards",
    meta: index4n6ORZ3YIbMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/index.vue")
  },
  {
    name: "location_identifier-gift-cards___ar",
    path: "/ar/:location_identifier()/gift-cards",
    meta: index4n6ORZ3YIbMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/index.vue")
  },
  {
    name: "location_identifier-gift-cards-review-and-confirm___en",
    path: "/en/:location_identifier()/gift-cards/review-and-confirm",
    meta: review_45and_45confirmcc1qjCuMruMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/review-and-confirm.vue")
  },
  {
    name: "location_identifier-gift-cards-review-and-confirm___ar",
    path: "/ar/:location_identifier()/gift-cards/review-and-confirm",
    meta: review_45and_45confirmcc1qjCuMruMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/gift-cards/review-and-confirm.vue")
  },
  {
    name: "location_identifier___en",
    path: "/en/:location_identifier()",
    meta: indexU5OcKHHkJfMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/index.vue")
  },
  {
    name: "location_identifier___ar",
    path: "/ar/:location_identifier()",
    meta: indexU5OcKHHkJfMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/index.vue")
  },
  {
    name: "location_identifier-memberships-checkout___en",
    path: "/en/:location_identifier()/memberships/checkout",
    meta: checkoutdA3m1ZKQ4sMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/checkout.vue")
  },
  {
    name: "location_identifier-memberships-checkout___ar",
    path: "/ar/:location_identifier()/memberships/checkout",
    meta: checkoutdA3m1ZKQ4sMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/checkout.vue")
  },
  {
    name: "location_identifier-memberships-finished___en",
    path: "/en/:location_identifier()/memberships/finished",
    meta: finishedYV39mFQVseMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/finished.vue")
  },
  {
    name: "location_identifier-memberships-finished___ar",
    path: "/ar/:location_identifier()/memberships/finished",
    meta: finishedYV39mFQVseMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/finished.vue")
  },
  {
    name: "location_identifier-memberships___en",
    path: "/en/:location_identifier()/memberships",
    meta: indexeMH2kPrkXfMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/index.vue")
  },
  {
    name: "location_identifier-memberships___ar",
    path: "/ar/:location_identifier()/memberships",
    meta: indexeMH2kPrkXfMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/index.vue")
  },
  {
    name: "location_identifier-memberships-review-and-confirm___en",
    path: "/en/:location_identifier()/memberships/review-and-confirm",
    meta: review_45and_45confirmAPLQ8W10ZZMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/review-and-confirm.vue")
  },
  {
    name: "location_identifier-memberships-review-and-confirm___ar",
    path: "/ar/:location_identifier()/memberships/review-and-confirm",
    meta: review_45and_45confirmAPLQ8W10ZZMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/memberships/review-and-confirm.vue")
  },
  {
    name: "location_identifier-products-slug___en",
    path: "/en/:location_identifier()/products/:slug(.*)*",
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[...slug].vue")
  },
  {
    name: "location_identifier-products-slug___ar",
    path: "/ar/:location_identifier()/products/:slug(.*)*",
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[...slug].vue")
  },
  {
    name: "location_identifier-products-id___en",
    path: "/en/:location_identifier()/products/:id()",
    meta: _91id_93E3ODSTE98lMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[id].vue")
  },
  {
    name: "location_identifier-products-id___ar",
    path: "/ar/:location_identifier()/products/:id()",
    meta: _91id_93E3ODSTE98lMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/[id].vue")
  },
  {
    name: "location_identifier-products___en",
    path: "/en/:location_identifier()/products",
    meta: indexvctjt23AjiMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/index.vue")
  },
  {
    name: "location_identifier-products___ar",
    path: "/ar/:location_identifier()/products",
    meta: indexvctjt23AjiMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(location)/[location_identifier]/products/index.vue")
  },
  {
    name: "business-types-slug___en",
    path: "/en/business-types/:slug()",
    meta: _91slug_93DRYCHPhXDWMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/business-types/[slug].vue")
  },
  {
    name: "business-types-slug___ar",
    path: "/ar/business-types/:slug()",
    meta: _91slug_93DRYCHPhXDWMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/business-types/[slug].vue")
  },
  {
    name: "business-types___en",
    path: "/en/business-types",
    meta: indexWJwxevf89WMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/business-types/index.vue")
  },
  {
    name: "business-types___ar",
    path: "/ar/business-types",
    meta: indexWJwxevf89WMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/business-types/index.vue")
  },
  {
    name: "contact-sales___en",
    path: "/en/contact-sales",
    meta: contact_45salesfzT1Bb7i8MMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/contact-sales.vue")
  },
  {
    name: "contact-sales___ar",
    path: "/ar/contact-sales",
    meta: contact_45salesfzT1Bb7i8MMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/contact-sales.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    meta: contact_45usK0o6IYM1CWMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/contact-us.vue")
  },
  {
    name: "contact-us___ar",
    path: "/ar/contact-us",
    meta: contact_45usK0o6IYM1CWMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/contact-us.vue")
  },
  {
    name: "faqs___en",
    path: "/en/faqs",
    meta: faqssiB4FDIIeGMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/faqs.vue")
  },
  {
    name: "faqs___ar",
    path: "/ar/faqs",
    meta: faqssiB4FDIIeGMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/faqs.vue")
  },
  {
    name: "features___en",
    path: "/en/features",
    meta: featuresOn9y2GfMHpMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/features.vue")
  },
  {
    name: "features___ar",
    path: "/ar/features",
    meta: featuresOn9y2GfMHpMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/features.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index3fLZKt80a0Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: index3fLZKt80a0Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    meta: privacy_45policyoTRQoWsrZzMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ar",
    path: "/ar/privacy-policy",
    meta: privacy_45policyoTRQoWsrZzMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/privacy-policy.vue")
  },
  {
    name: "request-demo___en",
    path: "/en/request-demo",
    meta: request_45demoAmN3fHNzXIMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/request-demo.vue")
  },
  {
    name: "request-demo___ar",
    path: "/ar/request-demo",
    meta: request_45demoAmN3fHNzXIMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/(website)/request-demo.vue")
  },
  {
    name: "account-bookings___en",
    path: "/en/account/bookings",
    meta: bookingsU8iC6CTcwKMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/bookings.vue")
  },
  {
    name: "account-bookings___ar",
    path: "/ar/account/bookings",
    meta: bookingsU8iC6CTcwKMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/bookings.vue")
  },
  {
    name: "account-change-email___en",
    path: "/en/account/change-email",
    meta: change_45emailBVEOOvYZjsMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/change-email.vue")
  },
  {
    name: "account-change-email___ar",
    path: "/ar/account/change-email",
    meta: change_45emailBVEOOvYZjsMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/change-email.vue")
  },
  {
    name: "account-change-mobile___en",
    path: "/en/account/change-mobile",
    meta: change_45mobileHINmejLMh5Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue")
  },
  {
    name: "account-change-mobile___ar",
    path: "/ar/account/change-mobile",
    meta: change_45mobileHINmejLMh5Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/change-mobile.vue")
  },
  {
    name: "account-delete___en",
    path: "/en/account/delete",
    meta: deleteWiFeWjmL7IMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/delete.vue")
  },
  {
    name: "account-delete___ar",
    path: "/ar/account/delete",
    meta: deleteWiFeWjmL7IMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/delete.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: indexlY1trGZ0VgMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/index.vue")
  },
  {
    name: "account___ar",
    path: "/ar/account",
    meta: indexlY1trGZ0VgMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/index.vue")
  },
  {
    name: "account-my-gift-cards___en",
    path: "/en/account/my-gift-cards",
    meta: my_45gift_45cardsWQceEdk5wkMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/my-gift-cards.vue")
  },
  {
    name: "account-my-gift-cards___ar",
    path: "/ar/account/my-gift-cards",
    meta: my_45gift_45cardsWQceEdk5wkMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/my-gift-cards.vue")
  },
  {
    name: "account-my-memberships___en",
    path: "/en/account/my-memberships",
    meta: my_45membershipszY9sAzuTtkMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/my-memberships.vue")
  },
  {
    name: "account-my-memberships___ar",
    path: "/ar/account/my-memberships",
    meta: my_45membershipszY9sAzuTtkMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/my-memberships.vue")
  },
  {
    name: "account-overdue___en",
    path: "/en/account/overdue",
    meta: overdueELYTIYCgubMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/overdue.vue")
  },
  {
    name: "account-overdue___ar",
    path: "/ar/account/overdue",
    meta: overdueELYTIYCgubMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/overdue.vue")
  },
  {
    name: "account-paid___en",
    path: "/en/account/paid",
    meta: paidb90QLIPW2rMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/paid.vue")
  },
  {
    name: "account-paid___ar",
    path: "/ar/account/paid",
    meta: paidb90QLIPW2rMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/paid.vue")
  },
  {
    name: "account-product-orders___en",
    path: "/en/account/product-orders",
    meta: product_45ordersvLaj95mgwUMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/product-orders.vue")
  },
  {
    name: "account-product-orders___ar",
    path: "/ar/account/product-orders",
    meta: product_45ordersvLaj95mgwUMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/product-orders.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    meta: settingsZNyow6wOj7Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/settings.vue")
  },
  {
    name: "account-settings___ar",
    path: "/ar/account/settings",
    meta: settingsZNyow6wOj7Meta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/settings.vue")
  },
  {
    name: "account-visited-locations___en",
    path: "/en/account/visited-locations",
    meta: visited_45locationswVIXQ9EbfXMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/visited-locations.vue")
  },
  {
    name: "account-visited-locations___ar",
    path: "/ar/account/visited-locations",
    meta: visited_45locationswVIXQ9EbfXMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/visited-locations.vue")
  },
  {
    name: "account-wallet___en",
    path: "/en/account/wallet",
    meta: walletVenzvYp6ThMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/wallet.vue")
  },
  {
    name: "account-wallet___ar",
    path: "/ar/account/wallet",
    meta: walletVenzvYp6ThMeta || {},
    component: () => import("/codebuild/output/src3679812873/src/online-profile-bookforme-nuxt/pages/account/wallet.vue")
  },
  {
    name: component_45stubycs6ORPvVsMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubycs6ORPvVs
  }
]